import { getBuildEnvironment } from 'utils/environment';

export const phone = '+49 22 198 253 169';
export const email = 'lumni@andersenlab.com';

export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';
export const EMPLOYEES_COUNT = '3,600+';
export const OFFICES_COUNT = '16';
export const ACCEPTABLE_TEXT_CHARACTERS = /[^а-яА-Яa-zA-ZёЁґєЄіІїЇ\-'\s]/;
export const PHONE_REGEX = /^[+0-9]{11,17}$/i;
export const NON_LATIN_CHARS = /[^\x20-\x7F]+/;
export const LATIN_CHARS = /^[\x20-\x7E\r\n№]+$/;
export const LATIN_CHARS_STRICT = /^[a-zA-Z\s-]+$/;
export const URL_PATTERN =
  /https:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*/;
export const DOMAIN_URL = (() => {
  switch (getBuildEnvironment()) {
    case 'development':
      return 'https://dev-traineeship-program-idda-azerbaijan.andersenlab.com/';
    case 'production':
    default:
      return ' https://traineeship-program-idda-azerbaijan.andersenlab.com/ ';
  }
})();
